import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { OverlayPositionX } from '../../../ui/gzSelect/types';

export const templateDownloadKitButtonSelector = document.createElement('template');

templateDownloadKitButtonSelector.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <style>${styleHelpersStyles}</style>
  <div class='wrapper'>
    <div>
      <gz-generic-overlay overlayid="overlay-40067739-122e-4596-8154-debd75b169db" id="mega-menu-overlay">
        <gz-button slot="target" id="mega-menu-button" type='quiet' color="secondary">
          <span id='download-package-actions-split-button-text' class='action-button-text'></span>
          <gz-icon name="ds-icon-dropdown_arrow" color="secondary" size="32"></gz-icon>
        </gz-button>
        <gz-mega-menu id="mega-menu-container"></gz-mega-menu>
      </gz-generic-overlay>
    </div>

  </div>
`;
